export default "{\n    \"placeholderText\": \"Grupo / Instalación\",\n    \"searchPlaceholderText\": \"Buscar por nombre de grupo o instalación\"\n}\n"